import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterShift } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterShift>();

export class CallCenterShiftFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterShift>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterShift)(filters);
  });
}
